import { Modal } from "@4uhub/lib4uhub";
import TopicIcon from "@mui/icons-material/Topic";
import { Box, Tooltip } from "@mui/material";
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import IconButton from "../../UI/IconButton";
import { ViewReportsPdfSerialTable } from "./ViewReportsPdfSerialTable/ViewReportsPdfSerialTable";
import { ReportsPdfSerialsModal } from "./ReportsPdfSerialsModal/ReportsPdfSerialsModal";
import { IReportsPdfSerialsProps } from "./models";

const translationPath = "components.reports.";

export const ReportsPdfSerial = memo(({ identifier,cdnUrl }: IReportsPdfSerialsProps) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const openModalHandler = () => setOpen(true);
  const closeModalHandler = () => setOpen(false);

  return (
    <>
      <Modal
        open={open}
        onClose={closeModalHandler}
        title={`${t(translationPath + "reports")}`}
        maxDialogWidth={"xs"}
      >
        <ReportsPdfSerialsModal identifier={identifier} cdnUrl={cdnUrl} />
      </Modal>

      <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
        <Tooltip title={t(translationPath + "view_reports")} placement="bottom">
          <Box>
            <IconButton onClick={openModalHandler}>
              <TopicIcon fontSize="small" />
            </IconButton>
          </Box>
        </Tooltip>

        <ViewReportsPdfSerialTable identifier={identifier} />
      </Box>
    </>
  );
});